// src/utils/portfolioType.ts

// หลังบ้านรองรับ portfolioType = CRYPTO แล้ว (ชนิดพอร์ตเปลี่ยนทีหลังไม่ได้)
// พอร์ตเก่าที่เคยสร้างเป็น STOCK แล้วใส่คำว่า crypto ในชื่อ จะถือเป็นพอร์ตหุ้นตามที่หลังบ้านเก็บจริง
export type PortfolioType = 'STOCK' | 'CRYPTO';

export const isCryptoPortfolio = (portfolio: any): boolean => {
  return portfolio?.portfolioType === 'CRYPTO';
};

export const getPortfolioType = (portfolio: any): PortfolioType => {
  return isCryptoPortfolio(portfolio) ? 'CRYPTO' : 'STOCK';
};

// symbol ที่ใช้ดึงราคา gateway ของเหรียญ (X:BTCUSD)
// หลังบ้านระบุ providerSymbol = X:{base}USD ถ้าไม่ได้ส่งมา ให้สร้างจาก assetSymbol
export const getCryptoPriceSymbol = (holding: any): string => {
  const candidates = [holding?.providerSymbol, holding?.assetSymbol, holding?.stockSymbol, holding?.symbol];
  const exact = candidates.find(s => typeof s === 'string' && /^X:/i.test(s));
  if (exact) return exact.toUpperCase();
  const base = String(holding?.displaySymbol || holding?.assetSymbol || holding?.symbol || '').toUpperCase().replace(/USD$/, '');
  return base ? `X:${base}USD` : '';
};

// symbol ของ holding ที่ใช้เทียบกับ symbol บนกราฟ: คริปโต = X:BTCUSD (assetSymbol เป็น BTC/USD จึงเทียบตรงๆ ไม่ได้)
export const holdingQuoteSymbol = (holding: any): string => {
  const isCrypto =
    holding?.assetType === 'CRYPTO' ||
    [holding?.providerSymbol, holding?.stockSymbol].some(s => typeof s === 'string' && /^X:/i.test(s));
  return isCrypto ? getCryptoPriceSymbol(holding) : (holding?.symbol || holding?.assetSymbol || holding?.stockSymbol || '');
};

// ปรับ holding ของพอร์ตคริปโตให้ stockSymbol เป็น X:...USD
// ทุกจุดที่หาราคาด้วย stockSymbol || assetSymbol จะได้ราคาคริปโตจาก gateway โดยไม่ต้องแก้ทีละที่
// (assetSymbol/assetId เดิมยังอยู่ครบ ใช้ตอนส่งรายการให้หลังบ้าน)
export const normalizeCryptoPortfolio = (portfolio: any) => {
  if (!isCryptoPortfolio(portfolio)) return portfolio;
  const normalizeHolding = (h: any) => {
    const priceSymbol = getCryptoPriceSymbol(h);
    return {
      ...h,
      stockSymbol: priceSymbol || h.stockSymbol,
      displaySymbol: h.displaySymbol || priceSymbol.replace(/^X:/, '').replace(/USD$/, ''),
    };
  };
  const mapSub = (sub: any) => ({
    ...sub,
    ...(sub.holdings ? { holdings: sub.holdings.map(normalizeHolding) } : {}),
    ...(sub.stocks ? { stocks: sub.stocks.map(normalizeHolding) } : {}),
  });
  return {
    ...portfolio,
    ...(portfolio.subPorts ? { subPorts: portfolio.subPorts.map(mapSub) } : {}),
    ...(portfolio.subPortfolios ? { subPortfolios: portfolio.subPortfolios.map(mapSub) } : {}),
    ...(portfolio.holdings ? { holdings: portfolio.holdings.map(normalizeHolding) } : {}),
  };
};
